import config from "config/appConfig";

// import type { SetState } from "zustand";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { createIndexedDBStorage } from "shared/services/indexDB/indexDB";
import type { BaseStateProps } from "shared/types";

const { GLOBAL_CONSTANTS } = config;

const createStoreFunction = <T>({
	initialState,
	persistant = false,
	persistantName = GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX,
	persistType = "localStorage"
}: {
	initialState: T;
	persistant?: boolean;
	persistantName?: string;
	persistType?: "localStorage" | "indexedDB";
}) => {
	const createState = (set: (partial: Partial<T & BaseStateProps>) => void) => {
		const init = {
			...initialState,
			isLoading: false,
			set,
			setState: set,
			setInitial: () => set(init)
		} as Partial<T & BaseStateProps>;

		return init;
	};

	// const createDataStore = persistant ? persist(createState, { name: persistantName }) : createState;

	const storage = persistType === "indexedDB" ? createIndexedDBStorage(persistantName!) : undefined;

	const createDataStore = persistant
		? /* @ts-expect-error: valid params */
			persist(createState, {
				name: persistantName,
				...(storage && { storage })
			})
		: createState;

	/* @ts-expect-error: valid params */
	return create<T & BaseStateProps>(devtools(createDataStore));
};

export default createStoreFunction;
